module.exports = __webpack_public_path__ + "public/img/zhinenggongyi.6757aaad.png";